export const APP_WIDTH = "lg";
export const SIDE_MENU_WIDTH = 200;

const allEntities = { APP_WIDTH, SIDE_MENU_WIDTH };
export default allEntities;
